import { render, staticRenderFns } from "./Report.vue?vue&type=template&id=c5a3028e&scoped=true&"
import script from "./Report.vue?vue&type=script&lang=js&"
export * from "./Report.vue?vue&type=script&lang=js&"
import style0 from "./Report.vue?vue&type=style&index=0&id=c5a3028e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a3028e",
  null
  
)

export default component.exports
import {QBtn,QTooltip,QDialog,QCard,QToolbar,QToolbarTitle,QScrollArea} from 'quasar'
component.options.components = Object.assign({QBtn,QTooltip,QDialog,QCard,QToolbar,QToolbarTitle,QScrollArea}, component.options.components || {})
